import React, {useContext, useEffect, useState} from "react";
import {getUtenteFromToken} from "../utility/common";
import {AuthContext} from "./AuthContext";
import {getRuoliApi} from "../features/ruoli/services/RuoliServices";

export const RuoliContext = React.createContext(0);

export const RuoliProvider = ({value, children}) => {

    const [ruoli, setRuoli] = useState()
    const [idRuolo, setIdRuolo] = useState()

    const {isLogged} = useContext(AuthContext);

    useEffect(() => {

        async function getRuoli() {
            const response = await getRuoliApi();
            setRuoli(response.data.data);
        }

        if (isLogged()) {
            getRuoli()

            const token = localStorage.getItem('ns-access-token');
            if (token) {
                const user = getUtenteFromToken(token)
                if (user) {
                    setIdRuolo(user.id_ruolo)
                }
            }
        }
    }, [isLogged]);

    const isIdRuoloSuperAdmin = (id) => {
        if (ruoli) {
            let filterSuperAd = ruoli.filter((item) => item.codice === 'SUADMIN');

            let ruolo = null;
            if (filterSuperAd && filterSuperAd.length > 0) {
                ruolo = filterSuperAd.reduce((item) => item)
            }
            return ruolo && ruolo.id_ruolo === id;
        } else {
            return false;
        }
    }

    const isIdRuoloAdmin = (id) => {
        if (ruoli) {
            let filterAd = ruoli.filter((item) => item.codice === 'ADMIN');

            let ruolo = null;
            if (filterAd && filterAd.length > 0) {
                ruolo = filterAd.reduce((item) => item)
            }
            return ruolo && ruolo.id_ruolo === id;
        } else {
            return false;
        }
    }

    const isIdRuoloOperatore = (id) => {
        if (ruoli) {
            let filterOp = ruoli.filter((item) => item.codice === 'OP');

            let ruolo = null;
            if (filterOp && filterOp.length > 0) {
                ruolo = filterOp.reduce((item) => item)
            }
            return ruolo && ruolo.id_ruolo === id;
        } else {
            return false;
        }
    }

    const isRuoloSuperAdmin = () => {
        if (idRuolo && ruoli) {
            return isIdRuoloSuperAdmin(idRuolo);
        } else {
            return false;
        }
    }

    const isRuoloAdmin = () => {
        if (idRuolo && ruoli) {
            return isIdRuoloSuperAdmin(idRuolo) || isIdRuoloAdmin(idRuolo);
        } else {
            return false;
        }
    }

    const isRuoloOperatore = () => {
        if (idRuolo && ruoli) {
            return isIdRuoloOperatore(idRuolo);
        } else {
            return false;
        }
    }

    // helper per confrontare ruoli
    const isRuolo = (ruoloIn) => {
        if (idRuolo && ruoli) {
            let ruolo = ruoli.filter((item) => item.codice === ruoloIn)
                .reduce((item) => item)
            return ruolo && ruolo.id_ruolo === idRuolo;
        } else {
            return false;
        }
    }

    return (
        <RuoliContext.Provider
            value={{
                ruoli,
                isRuoloSuperAdmin,
                isRuoloAdmin,
                isRuoloOperatore,
                isIdRuoloSuperAdmin,
                isIdRuoloAdmin,
                isIdRuoloOperatore,
                codiceRuoloSuperAdmin: 'SUADMIN',
                codiceRuoloAdmin: 'ADMIN',
                codiceRuoloOperatore: 'OP',
            }}>{children}</RuoliContext.Provider>
    );
};
